module.exports = __webpack_public_path__ + "img/willard.47759bde.png";